import axios, { AxiosRequestConfig } from 'axios';
import { useToken } from '../contexts/tokenContext';
import { GroupType } from '../entities/GroupType';

export const useCreateGroupType = () => {
	const token = useToken();
	return async (form: any): Promise<GroupType | null> => {
		try {
			if (!token?.accessToken) {
				return null;
			}

			const params: AxiosRequestConfig = {
				method: 'POST',
				url: '/group_type',
				data: form,
				withCredentials: true,
			};
			const result = await axios.request(params);
			return result.data;
		} catch (error) {
			throw error;
		}
	};
};
